import React from 'react';
import Sidebar from '../components/Nav/Sidebar';
import Topbar from '../components/Nav/Topbar';
import Footer from '../components/Common/Footer';

const PageContainer = ({ children }) => {
  return (
    <div className="page">
      <Sidebar />
      <div className="main-content side-content pt-0">
        <Topbar />
        <div className="container-fluid">
          {children}
        </div>
      </div>
      {/* <RightSideBar /> */}
      <Footer />
    </div>
  );
};

export default PageContainer;